export default __webpack_public_path__ + "static/media/Img_utility_scale_project_2.b3886001.svg";